import {Model, HttpIgnore, ResponseFill, IResource, ID} from 'simpli-web-sdk'
import {ItrackCollection} from '@/helpers'

@HttpIgnore()
export default class ResponsavelUsuarioRequest extends Model {
  readonly $name: string = 'ResponsavelUsuarioRequest'

  allFilial = ItrackCollection.allFilialFilter.prependNull('app.all')

  @ResponseFill()
  idFilial: ID | null = null

  get filial() {
    return this.allFilial.get(this.idFilial)
  }
  set filial(val: IResource | null) {
    this.idFilial = val && val.$id as number || null
  }
}
